/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicGovernanceConfigurationValidation extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicGovernanceConfigurationValidation");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicGovernanceConfigurationValidation.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicGovernanceConfigurationValidation>): BackgroundJobPayloadForPeriodicGovernanceConfigurationValidation {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicGovernanceConfigurationValidation(), model);
        BackgroundJobPayloadForPeriodicGovernanceConfigurationValidation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicGovernanceConfigurationValidation>): BackgroundJobPayloadForPeriodicGovernanceConfigurationValidation {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicGovernanceConfigurationValidation.newInstance(<BackgroundJobPayloadForPeriodicGovernanceConfigurationValidation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicGovernanceConfigurationValidation) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicGovernanceConfigurationValidation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicGovernanceConfigurationValidation): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicGovernanceConfigurationValidation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
